module.exports = {"431223100":"辰阳镇","431223101":"孝坪镇","431223102":"田湾镇","431223103":"火马冲镇","431223104":"黄溪口镇","431223105":"潭湾镇","431223106":"安坪镇","431223108":"锦滨镇","431223109":"修溪镇","431223200":"船溪乡","431223204":"长田湾乡","431223205":"小龙门乡","431223206":"后塘瑶族乡","431223207":"苏木溪瑶族乡","431223208":"罗子山瑶族乡","431223209":"上蒲溪瑶族乡","431223210":"仙人湾瑶族乡","431223211":"龙头庵乡","431223215":"大水田乡","431223216":"桥头溪乡","431223218":"龙泉岩乡","431223221":"柿溪乡","431223222":"谭家场乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431223.json
// module id = 1920
// module chunks = 0